import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./DesignServices.css";

const imageSets = {
  stadPro: ["/design/stad/1.jpg", "/design/stad/2.jpg", "/design/stad/3.jpg"],
  piping: [
    "/design/piping/1.jpg",
    "/design/piping/2.jpg",
    "/design/piping/3.jpg",
  ],
  electricalLighting: [
    "/design/lighting/1.jpg",
    "/design/lighting/2.jpg",
    "/design/lighting/3.jpg",
  ],
  teklaDesign: [
    "/design/tekla/1.jpg",
    "/design/tekla/2.jpg",
    "/design/tekla/3.jpg",
  ],
};

const ImageSlider = ({ images }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="slider-container">
      <img src={images[index]} alt="Slide" className="slider-image" />
      <div className="slider-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

const DesignServices = () => {
  return (
    <>
      <div className="hero-section">
        <Container>
          <Row className="align-items-center min-vh-50">
            <Col md={6}>
              <h1 className="display-4 fw-bold mb-4">
                Design <span className="text-primary">Services</span>
              </h1>
              <p className="lead mb-4">
                Delivering innovative engineering solutions with precision and
                excellence.
              </p>
              <button className="btn btn-primary btn-lg">Get Started</button>
            </Col>
            <Col md={6}>
              <img
                src="/Picture1.jpg"
                alt="Engineering Design"
                className="hero-image"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="py-5">
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="section-title">Our Design Solutions</h2>
            <p className="section-subtitle">
              Comprehensive engineering design services for your projects
            </p>
          </Col>
        </Row>

        <Row className="g-4">
          {/* STADPro Section */}
          <Col lg={4}>
            <Card className="service-card">
              <div className="card-image-wrapper">
                <ImageSlider images={imageSets.stadPro} />
                <div className="image-overlay">
                  <h3>STADPro</h3>
                </div>
              </div>
              <Card.Body>
                <Card.Title>STADPro</Card.Title>
                <Card.Text>
                  Advanced structural analysis and design solutions with
                  STADPro. Create efficient and reliable structural designs.
                </Card.Text>
                {/* <button className="btn btn-outline-primary">Learn More</button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Piping Section */}
          <Col lg={4}>
            <Card className="service-card">
              <div className="card-image-wrapper">
                <ImageSlider images={imageSets.piping} />
                <div className="image-overlay">
                  <h3>Piping</h3>
                </div>
              </div>
              <Card.Body>
                <Card.Title>Piping</Card.Title>
                <Card.Text>
                  Optimized piping designs for industrial and commercial
                  projects. Ensuring efficient fluid flow systems.
                </Card.Text>
                {/* <button className="btn btn-outline-primary">Learn More</button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Electrical Lighting Section */}
          <Col lg={4}>
            <Card className="service-card">
              <div className="card-image-wrapper">
                <ImageSlider images={imageSets.electricalLighting} />
                <div className="image-overlay">
                  <h3>Electrical Lighting</h3>
                </div>
              </div>
              <Card.Body>
                <Card.Title>Electrical Lighting</Card.Title>
                <Card.Text>
                  Efficient lighting solutions for residential, commercial, and
                  industrial needs. Smart and sustainable designs.
                </Card.Text>
                {/* <button className="btn btn-outline-primary">Learn More</button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Tekla Design Section */}
          {/* <Col lg={4}>
            <Card className="service-card">
              <div className="card-image-wrapper">
                <ImageSlider images={imageSets.teklaDesign} />
                <div className="image-overlay">
                  <h3>Tekla Design</h3>
                </div>
              </div>
              <Card.Body>
                <Card.Title>Tekla Design</Card.Title>
                <Card.Text>
                  Comprehensive Tekla design solutions for structural modeling,
                  detailing, and project collaboration.
                </Card.Text>
                <button className="btn btn-outline-primary">Learn More</button>
              </Card.Body>
            </Card>
          </Col> */}

          <section className="expertise-section py-5">
            <Container>
              <Row className="justify-content-center">
                <Col md={10} lg={8}>
                  <h2 className="text-center mb-4">Our Expertise</h2>
                  <p className="text-center expertise-text">
                    We excel in providing comprehensive engineering design
                    services across multiple disciplines. Our expertise
                    encompasses structural analysis with STADPro, detailed
                    piping system design, electrical & lighting layouts, and
                    advanced BIM implementation. We deliver precise technical
                    documentation, detailed drawings, and specifications that
                    meet international standards.
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
        </Row>
      </Container>
    </>
  );
};

export default DesignServices;
